import {AppSettings} from "@/shared/models/AppSettings.ts";
import {t} from "@/shared/i18n/i18n.ts";

export const appSettings = {
    title: () => {
        return t('app.name')
    },
    name: () => "Checkout",
    basePath: () => process.env.APP_BASE_PATH,
} as AppSettings